<form class="link-appendix-dialog" name="linkAppendixForm" #f="ngForm"
  appFocusFirstElement (ngSubmit)="f.form.valid && confirm()" aria-labelledby="link-appendix-dialog-title">
  <h2 id="link-appendix-dialog-title" mat-dialog-title mat-dialog-draggable-title>
    {{'record_management_moha.link_document_appendix' | translate}}
    <button type="button" class="close" [attr.aria-label]="'button.close' | translate"
      [disabled]="submitting" (mousedown)="$event.stopPropagation()" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>

  <mat-dialog-content class="link-appendix-dialog__content">
    <section class="appendix-selection" aria-labelledby="appendix-selection-title">
      <h3 id="appendix-selection-title">
        {{ (data.worker.name ? 'record_management_moha.employee_appendix_list' : 'record_management_moha.original_contract_appendix_list') | translate }}
        <span>
          {{ data.worker.name ? ((data.worker.certificateNo ? data.worker.certificateNo + ' - ' : '') +
          data.worker.name) : data.worker.codeAndName }}
        </span>
      </h3>

      <label class="appendix-search">
        <mat-icon aria-hidden="true">search</mat-icon>
        <input type="text" name="nameOrCode" [ngModel]="searchText" (ngModelChange)="onSearchChange($event)"
          (blur)="onBlurSearch()" [disabled]="submitting"
          [placeholder]="'record_management_moha.search_by_document_name_or_code' | translate" maxlength="255"
          autocomplete="off" (keydown.enter)="$event.preventDefault(); retrySearch()" />
      </label>

      <div class="appendix-list" role="list" tabindex="0" aria-label="Danh sách phụ lục" [attr.aria-busy]="loading || submitting">
        <div
          class="appendix-item"
          role="listitem"
          *ngFor="let appendix of appendices; trackBy: trackAppendix"
          [class.appendix-item--selected]="appendix.selected"
          [class.appendix-item--disabled]="appendix.disabled"
          (click)="toggleAppendix(appendix, !appendix.selected)"
        >
          <mat-checkbox
            color="primary"
            [(ngModel)]="appendix.selected"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="submitting || appendix.disabled"
            [aria-label]="'Chọn ' + appendix.name"
            (click)="$event.stopPropagation()"
            (change)="toggleAppendix(appendix, $event.checked)"
          ></mat-checkbox>

          <div class="appendix-item__copy">
            <strong [matTooltip]="appendix.name">{{ appendix.name }}</strong>
            <span>
              {{'record_management_moha.document_code' | translate}} {{ appendix.documentCode }}
              <ng-container *ngIf="appendix.signedDate"> | {{'record_management_moha.signing_date' | translate}} {{ appendix.signedDate | date:'dd/MM/yyyy' }}</ng-container>
            </span>
          </div>
        </div>

        <div class="appendix-empty" role="status" *ngIf="loading">
          <mat-progress-bar mode="indeterminate" aria-label="Đang tải danh sách phụ lục"></mat-progress-bar>
        </div>
        <div class="appendix-empty" *ngIf="!loading && !loadError && appendices.length === 0">
          {{ 'messages.data_not_found' | translate }}
        </div>
        <div class="appendix-empty" style="color: #ed174c;" *ngIf="!loading && loadError">
          {{ loadErrorMessage || ('messages.error_message' | translate) }}
        </div>
      </div>
    </section>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions class="link-appendix-dialog__actions">
    <button mat-stroked-button color="primary" class="cancel-button" type="button" cdkFocusInitial
      [disabled]="submitting" (click)="onNoClick()">
      <mat-icon>cancel</mat-icon>
      {{ 'button.cancel' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="confirm-button"
      type="submit"
      [disabled]="submitting"
    >
      <mat-icon>save</mat-icon>
      {{'record_management_moha.confirm_link' | translate}}
    </button>
  </mat-dialog-actions>
</form>
